import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { Plan } from "src/app/models/PlanesUsuario/Plan";
import { PlanUsuario } from "src/app/models/PlanesUsuario/PlanUsuario";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { SessionUser } from "src/app/shared/models/sessionUser";
import { CERT_PRECIOS } from "src/app/components/configuracion-dte/mantenedor-certificados/config-certificados";
import { CertificadoCompraWizard } from "src/app/models/Emisor/EmisorWizardRequest";

@Component({
	selector: "app-planes-bloque",
	templateUrl: "./planes-bloque.component.html",
	styleUrls: ["./planes-bloque.component.scss"],
})
export class PlanesBloqueComponent implements OnInit {
	@Input() public planes: Plan[];
	@Input() public planSeleccionado: Plan;
	@Input() public planUsuario: PlanUsuario;
	@Input() public type: string;

	@Input()  public compraCertificado: CertificadoCompraWizard;
	@Output() public actualizarCertificado = new EventEmitter<CertificadoCompraWizard>();
	public CERT_PRECIOS = CERT_PRECIOS;   
	public user: SessionUser;
	public planOriginal: Plan = null;
	@Output() public actualizarPlan: EventEmitter<Plan> = new EventEmitter<Plan>();
	constructor(private tokenService: TokenStorageService) {
		this.user = this.tokenService.getUser() as SessionUser;
	}

	ngOnInit(): void {
	}
	ngOnChanges(changes: SimpleChanges): void {
		if (changes["planSeleccionado"] && !this.planOriginal) {
			this.planOriginal = changes["planSeleccionado"].currentValue;
		}
	}

	updatePlan(plan: Plan) {		
		this.actualizarPlan.emit(plan);
	}

	
}
